import(/* webpackMode: "eager" */ "/Users/rohangupta/creatr/platform/creatr-platform/apps/frontend/src/app/error.tsx");
